import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { paths } from '../../routes/paths';
import OAuthButton from '../../components/auth/OAuthButton/OAuthButton';
import Button from '../../components/ui/Button/Button';
import Icon from '../../components/ui/Icon/Icon';
import { IS_LOCAL } from '../../lib/config';
import styles from './LoginPage.module.css';

const ASCII_BIRD = `
   ___________________________
  |  >  SABIA // TERMINAL v1  |
  |  >  initializing crew...  |
  |  >  syncing worlds...     |
  |  >  ready_                 |
   ---------------------------
`;

export default function LoginPage() {
  const { login, loginAsGuest, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  if (!loading && isAuthenticated) {
    return <Navigate to={paths.workspaces} replace />;
  }

  const handleLogin = (provider) => login(provider);

  const handleGuest = async () => {
    try {
      await loginAsGuest();
      navigate(paths.workspaces, { replace: true });
    } catch {
      /* not available outside local */
    }
  };

  return (
    <div className={styles.page}>
      <section className={styles.brandPanel}>
        <div className={styles.brandInner}>
          <div className={styles.tag}>[ sabia // collaborative-writing-os ]</div>
          <h1 className={styles.tagline}>
            <span className={styles.taglineLine}>WRITE SCREENPLAYS.</span>
            <span className={styles.taglineLine}>BUILD WORLDS.</span>
            <span className={styles.taglineLineAccent}>CREATE TOGETHER.</span>
          </h1>
          <p className={styles.subtitle}>
            Crew up. Draft scenes, novels, and notes — live, in one terminal.
            No headaches. No corporate fluff.
          </p>
          <pre className={styles.ascii} aria-hidden="true">{ASCII_BIRD}</pre>
          <div className={styles.metrics}>
            <span><Icon name="Users" size={12} tone="accent" />&nbsp;CO-AUTHORS</span>
            <span><Icon name="Zap" size={12} tone="accent" />&nbsp;REAL-TIME SYNC</span>
            <span><Icon name="FileText" size={12} tone="accent" />&nbsp;EXPORT PDF</span>
          </div>
        </div>
      </section>

      <section className={styles.formPanel}>
        <div className={styles.card}>
          <div className={styles.cardKicker}>[ auth_terminal ]</div>
          <h2 className={styles.cardTitle}>
            sign_in<span className={styles.caret}>_</span>
          </h2>
          <p className={styles.cardSubtitle}>&gt; continue to your workspaces</p>

          <div className={styles.providers}>
            <OAuthButton provider="google" onClick={handleLogin} />
            <OAuthButton provider="github" onClick={handleLogin} />
          </div>

          {IS_LOCAL && (
            <>
              <div className={styles.divider}>
                <span>{'// or'}</span>
              </div>
              <Button fullWidth variant="terminal" onClick={handleGuest}>
                continue as guest
              </Button>
            </>
          )}

          <p className={styles.legal}>
            &gt; provider account is used for identity only. zero posting on your
            behalf. zero tracking.
          </p>
        </div>
      </section>
    </div>
  );
}
